<template>
    <span>
        <span v-if="$attrs.disabled"
              :data-original-title="title"
              class="cursor-pointer"
              data-placement="top"
              data-toggle="tooltip"
        >
            <i :class="icon" class="fas icon-disabled"></i>
        </span>
        <a v-else
           :data-original-title="title"
           data-placement="top"
           data-toggle="tooltip"
           v-bind="$attrs"
        >
            <i :class="icon" class="fas"></i>
        </a>
    </span>
</template>

<script>
import {Fragment} from 'vue-fragment';

export default {
    inheritAttrs: false,
    name: "TableIcon",
    components: {Fragment},
    props: {
        title: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: '',
        },
    },
};
</script>
